import { Icon } from "../../../assets/icons/Icon";
import { formatNumber } from "../../../helpers/helpers";
import MiddleTruncateTextPx from "../../dashboard/PageTable/MiddleTruncateUrl";
import Spinner from "../../ui/spinner/Spinner";
import styles from "./styles.module.scss";

interface PageListItemProps {
  page: {
    url?: string;
    title?: string;
    approved: number;
    total: number;
  };
  isPending?: boolean;
}

const PageListItem = ({ page, isPending }: PageListItemProps) => {
  return (
    <>
      {/*
       // @ts-expect-error TS2339 non-existing className */}
      <div className={styles.pageItemPath} title={page?.url}>
        {page.url ? (
          <MiddleTruncateTextPx
            text={page.url}
            maxWidth={280}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          />
        ) : (
          <div>{page?.title}</div>
        )}
      </div>
      {page.approved === page.total ? (
        isPending ? (
          <Spinner size="1rem" />
        ) : (
          <Icon iconName="GreenCheckmarkIcon" width="1rem" height="1rem" />
        )
      ) : (
        <div>
          {isPending ? (
            <Spinner size="1rem" />
          ) : (
            `${formatNumber(page.approved)}/${formatNumber(page.total)}`
          )}
        </div>
      )}
    </>
  );
};

export default PageListItem;
